/**
 * @generated SignedSource<<86fc230cd28d8633cc65b2050ef603af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OnSheetNoteByNotePlayer_Piece$data = {
  readonly id: string;
  readonly file: {
    readonly notes: ReadonlyArray<{
      readonly bulb_id: string;
      readonly midi_number: number;
      readonly left_handed: boolean;
      readonly note_start: number;
    }>;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SheetRenderer_piece">;
  readonly " $fragmentType": "OnSheetNoteByNotePlayer_Piece";
};
export type OnSheetNoteByNotePlayer_Piece$key = {
  readonly " $data"?: OnSheetNoteByNotePlayer_Piece$data;
  readonly " $fragmentSpreads": FragmentRefs<"OnSheetNoteByNotePlayer_Piece">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OnSheetNoteByNotePlayer_Piece",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MusicPieceFile",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MusicPieceFileNote",
          "kind": "LinkedField",
          "name": "notes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bulb_id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "midi_number",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "left_handed",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "note_start",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SheetRenderer_piece"
    }
  ],
  "type": "MusicPiece",
  "abstractKey": null
};

(node as any).hash = "5ece4b1524c14143a0c7da2b6f410b8f";

export default node;
